import { useEffect, useState } from 'react';
import { assetUrl } from '../../images/imageTools';
import { getAsset } from '../../storage/repo';

const resolved = new Map<string, string>();
const pending = new Map<string, Promise<string | null>>();

export function loadAssetUrl(id: string): Promise<string | null> {
  const hit = resolved.get(id);
  if (hit) return Promise.resolve(hit);
  let p = pending.get(id);
  if (!p) {
    p = getAsset(id)
      .then((a) => {
        if (!a) return null;
        const url = assetUrl(a);
        resolved.set(id, url);
        return url;
      })
      .catch(() => null)
      .finally(() => pending.delete(id));
    pending.set(id, p);
  }
  return p;
}

/** Object URL for a stored asset (cached for the session). `undefined` while loading, `null` if missing. */
export function useAssetUrl(id: string | null | undefined): string | null | undefined {
  const [url, setUrl] = useState<string | null | undefined>(() => (id ? resolved.get(id) : null));
  useEffect(() => {
    if (!id) {
      setUrl(null);
      return;
    }
    const hit = resolved.get(id);
    if (hit) {
      setUrl(hit);
      return;
    }
    let alive = true;
    setUrl(undefined);
    void loadAssetUrl(id).then((u) => alive && setUrl(u));
    return () => {
      alive = false;
    };
  }, [id]);
  return url;
}
